var aroundthebend = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/aroundthebend.jpg'
var torque = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/torque.jpg'
var chrysalis = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/chrysalis.jpg'
var slide = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/slide.jpg'
var slideDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/slideDetail1.jpg'
var slideDetail2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/slideDetail2.jpg'
var clasp = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/clasp.jpg'
var claspDetail = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/claspDetail.jpg'
var backbend = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/backbend.jpg'
var backbendDetail = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/backbend_detail.jpg'

export const allImagesDesktopOrderOnBalance = [
  [/*COLUMN 1*/
      [
          {
              name: backbend,
              artistName: "Lorraine Shemesh",
              title: "Backbend",
              year: "2022",
              dimensions: "60 1/4 x 52 in., o/c",
              link: "ob9",
              privateCollection: ""
          },
          {
              name: backbendDetail,
              artistName: "Lorraine Shemesh",
              title: "Backbend - detail",
              year: "2022",
              dimensions: "60 1/4 x 52 in., o/c ",
              link: "ob10",
              privateCollection: ""
          }
      ],
      [
          {
              name: torque,
              artistName: "Lorraine Shemesh",
              title: "Torque",
              year: "2023",
              dimensions: "64 x 40 in., o/c",
              link: "ob2",
              privateCollection: ""
          },
      ]
  ],
  [/*COLUMN 2*/
      [
          {
              name: chrysalis,
              artistName: "Lorraine Shemesh",
              title: "Chrysalis",
              year: "2023",
              dimensions: "60 x 42 in., o/c",
              link: "ob3",
              privateCollection: ""
          }
      ],
      [
          {
              name: slide,
              artistName: "Lorraine Shemesh",
              title: "Slide",
              year: "2020",
              dimensions: "58 x 60 1/2 in., o/c",
              link: "ob4",
              privateCollection: ""
          },
          {
              name: slideDetail1,
              artistName: "Lorraine Shemesh",
              title: "Slide - detail",
              year: "2020",
              dimensions: "58 x 60 1/2 in., o/c",
              link: "ob5",
              privateCollection: ""
          },
          {
              name: slideDetail2,
              artistName: "Lorraine Shemesh",
              title: "Slide - detail",
              year: "2020",
              dimensions: "58 x 60 1/2 in., o/c",
              link: "ob6",
              privateCollection: ""
          }
      ]
  ],
  [/*COLUMN 3*/
      [
          {
              name: clasp,
              artistName: "Lorraine Shemesh",
              title: "Clasp",
              year: "2022",
              dimensions: "55 11/16 x 53 5/8 in., o/c",
              link: "ob7",
              privateCollection: ""
          },
          {
              name: claspDetail,
              artistName: "Lorraine Shemesh",
              title: "Clasp - detail",
              year: "2022",
              dimensions: "55 11/16 x 53 5/8 in., o/c",
              link: "ob8",
              privateCollection: ""
          }
      ],
      [
          {
              name: aroundthebend,
              artistName: "Lorraine Shemesh",
              title: "Around the Bend",
              year: "2023",
              dimensions: "62 x 43 1/2 in., o/c",
              link: "ob1",
              privateCollection: ""
          },
      ]
  ]          
]

export const allImagesMobileOrderOnBalance = [
[
    {
        name: backbend,
        artistName: "Lorraine Shemesh",
        title: "Backbend",
        year: "2022",
        dimensions: "60 1/4 x 52 in., o/c",
        link: "ob9",
        privateCollection: ""
    },
    {
        name: backbendDetail,
        artistName: "Lorraine Shemesh",
        title: "Backbend - detail",
        year: "2022",
        dimensions: "60 1/4 x 52 in., o/c ",
        link: "ob10",
        privateCollection: ""
    },
    {
        name: torque,
        artistName: "Lorraine Shemesh",
        title: "Torque",
        year: "2023",
        dimensions: "64 x 40 in., o/c",
        link: "ob2",
        privateCollection: ""
    },
    {
        name: chrysalis,
        artistName: "Lorraine Shemesh",
        title: "Chrysalis",
        year: "2023",
        dimensions: "60 x 42 in., o/c",
        link: "ob3",
        privateCollection: ""
    },
    {
        name: slide,
        artistName: "Lorraine Shemesh",
        title: "Slide",
        year: "2020",
        dimensions: "58 x 60 1/2 in., o/c",
        link: "ob4",
        privateCollection: ""
    },
    {
        name: slideDetail1,
        artistName: "Lorraine Shemesh",
        title: "Slide - detail",
        year: "2020",
        dimensions: "58 x 60 1/2 in., o/c",
        link: "ob5",
        privateCollection: ""
    },
    {
        name: slideDetail2,
        artistName: "Lorraine Shemesh",
        title: "Slide - detail",
        year: "2020",
        dimensions: "58 x 60 1/2 in., o/c",
        link: "ob6",
        privateCollection: ""
    },
    {
        name: clasp,
        artistName: "Lorraine Shemesh",
        title: "Clasp",
        year: "2022",
        dimensions: "55 11/16 x 53 5/8 in., o/c",
        link: "ob7",
        privateCollection: ""
    },
    {
        name: claspDetail,
        artistName: "Lorraine Shemesh",
        title: "Clasp - detail",
        year: "2022",
        dimensions: "55 11/16 x 53 5/8 in., o/c",
        link: "ob8",
        privateCollection: ""
    },
    {
        name: aroundthebend,
        artistName: "Lorraine Shemesh",
        title: "Around the Bend",
        year: "2023",
        dimensions: "62 x 43 1/2 in., o/c",
        link: "ob1",
        privateCollection: ""
    }
]
]